import styled from '@emotion/styled'
import { CardFaqs } from '../CardFaqs'

const CardResultFaqs = styled(CardFaqs)`
  border-radius: 8px;
  background-color: #171717;
  padding: 26px 22px;
  width: 100%;
  gap: 22px;
  flex-direction: row-reverse;
  justify-content: ${({ image }) => (image ? 'space-between' : 'flex-end')};
  border: 1px solid transparent;
  &:hover {
    border: 1px solid #313131;
  }
  & img {
    width: 77px;
    height: 77px;
    margin: 0 10px 0 20px;
  }
  & .css-0 > {
    :nth-of-type(1) {
      color: #777;
      font-size: 23px;
      font-weight: 500;
    }
    :nth-of-type(2) {
      font-size: 15px;
    }
  }
`

export default { CardResultFaqs }
